export default "__VITE_ASSET__DHx5Aq$4__"